<!-- TEMPLATE -->
<template>
  <div :class='contactsListClass'>
    <div class='row'>
      <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
        <dean-section-title content='true'>
            <span slot='title'>
              <span class='avenir-heavy'>{{title}}</span>
            </span>
          <dean-section-title-item v-if="!showArchive"
                                   :icon='archiveIcon'
                                   :content="true"
                                   @click.native="sectionRoute('profile.contacts.status', {status: 'verwijderd'})"
          >
            archief
          </dean-section-title-item>
          <dean-section-title-item v-else
                                   :icon='returnIcon'
                                   :content="true"
                                   @click.native="sectionRoute('profile.contacts')"
          >
            Terug naar actief
          </dean-section-title-item>
          <dean-section-title-item
                  v-if="$store.getters.getUser.privileges.includes('create-contact')"
                  :icon='plusIcon'
                  :content="true"
                  @click.native="sectionRoute('profile.contact.add')"
          >
            Nieuw
          </dean-section-title-item>
        </dean-section-title>
        <dean-table
                :data='contactsData'
                :columns='columns'
                :hover="$store.getters.getUser.privileges.includes('update-contact')"
                @column-click='columnClick'
                @cell-click="cellClick"
        >
        </dean-table>
        <dean-pagination
                :current-page='contactsMetaData.pageNumber'
                :total-items='contactsMetaData.totalResults'
                :items-per-page='contactsMetaData.itemsPerPage'
                :select-items-per-page='selectItemsPerPage'
                :visible-pages='contactsMetaData.visiblePages'
                @page-changed='paginationChanged'
                @items-per-page='itemsPerPageChanged'
        >
        </dean-pagination>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
  // VUE
  import {
    Vue,
    Component,
  } from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import sideMenuProfileMixin from '@/mixins/sideMenuProfileMixin';
  import {mixins} from 'vue-class-component';

  import {
    // SVG
    invoicesIcon,
    archiveIcon,
    returnIcon,
    // COMPONENTS
    deanTable,
    deanPagination,
    deanInputSelect,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSearchField,
    deanIcon,
    plusIcon,
    summeryIcon,
  } from '@deanone/dean-components';

  @Component({
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      invoicesIcon,
      deanIcon,
      plusIcon,
      summeryIcon,
    },
  })
  export default class List extends mixins(deanTableMixin, sideMenuProfileMixin) {
    public url: string = '/-/trade/api/person.contact.list';
    public showSomething: boolean = false;
    public plusIcon: object = plusIcon;
    public archiveIcon: object = archiveIcon;
    public returnIcon: object = returnIcon;
    public data: object[] = [];
    public showArchive: boolean = false;
    public queryTimeout!: number;

    // COMPUTED
    get contactsListClass() {
      let value = 'address-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get contactsMetaData() {
      return this.pageMeta;
    }

    get contactsData() {
      return this.data;
    }

    get title() {
      return this.showArchive ? 'Verwijderde contacten' : 'Contacten';
    }

    public columns: any = {
      name: {
        content: 'Naam',
        align: 'left',
        sort: true,
        dql: 'name',
      },
      receivesInvoices: {
        content: 'ontvangt facturen',
        align: 'left',
        sort: true,
        dql: 'invoices',
      },
      receivesNotifications: {
        content: 'ontvangt berichten',
        align: 'left',
        sort: true,
        dql: 'notifications',
      },
    };

    public tableName(): string {
      return 'profile-contacts';
    }

    public cellClick(target: { cell: object, row: { id: string }, column: string }) {
      if (this.$store.getters.getUser.privileges.includes('update-contact')) {
        this.$router.push({
          name: 'profile.contact.edit',
          params: {id: target.row.id},
        });
      }
    }

    // METHODS
    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);

      const params = {
        id: this.$store.getters.getUser.organizationId,
        meta: {
          startIndex: this.startIndex,
          numberOfItems: data.itemsPerPage,
        },
        filter: data.query,
        deleted: this.showArchive ? true : undefined,
        sort: data.sort,
        isUser: false,
      };

      axios.post(this.url, params)
        .then(
          (contactsResponse: any) => {
            this.data = contactsResponse.data.data.map((contact: any) => {
              return {
                id: contact.id,
                name: contact.name,
                receivesInvoices: contact.receivesInvoices ? 'Ja' : 'Nee',
                receivesNotifications: contact.receivesNotifications ? 'Ja' : 'Nee',
              };
            });

            this.updateMeta(contactsResponse.data.meta);
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        ).finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    public update(timeout: boolean) {
      this.pageMeta.pageNumber = 1;

      const self = this;
      const meta: any = self.pageMeta;

      if (timeout) {
        if (this.queryTimeout) {
          clearTimeout(this.queryTimeout);
        }
        this.queryTimeout = setTimeout(() => {
          self.loadList(meta);
        }, 500);
      } else {
        this.loadList(meta);
      }
    }

    public created() {
      this.showArchive = this.$router.currentRoute.params.status === 'verwijderd';
      this.keepMetaSavedInState();
      this.setDefaultSort('name');
      this.loadList(this.pageMeta);
      this.buildSideMenuProfile();
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
  @import '~@deanone/dean-components/src/scss/vars';
</style>
